
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { FileText } from 'lucide-react';
import { CustomerData } from '@/hooks/admin/types';
import { convertCustomersToCSV, downloadCSV } from '@/lib/export';
import { format } from 'date-fns';

interface ExportButtonProps {
  customers: CustomerData[];
  isDisabled?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({ 
  customers, 
  isDisabled = false 
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    try {
      setIsExporting(true);
      
      // Track the export event in Facebook Pixel
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('trackCustom', 'ExportUsers', {
          count: customers.length
        });
      }

      // Format current date for filename
      const dateStr = format(new Date(), 'yyyy-MM-dd');
      const fileName = `dropify-users-${dateStr}.csv`;
      
      // Convert and download
      const csvContent = convertCustomersToCSV(customers);
      downloadCSV(csvContent, fileName);
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button 
      onClick={handleExport}
      disabled={isDisabled || isExporting || customers.length === 0}
      variant="outline"
      size="sm"
      className="flex items-center gap-1"
    >
      <FileText size={16} className={isExporting ? 'animate-pulse' : ''} />
      {isExporting ? 'Exporting...' : 'Export Users'}
    </Button>
  );
};

export default ExportButton;
